module.exports = __webpack_public_path__ + "media/images/opnioes/testmonial-lattes-4c2ff7bb59218cf5c921da44e15febd3.png";